<template>
  <div class="wrap">
    <div class="box" :class="index<stepsData.length-1?'boxAfter':''" v-for="(item,index) in stepsData" :key="index">
      <!-- 之后一步 -->
      <div class="steps" v-if="stepsIndex<index">
        <div class="iconN" style="">{{index+1}}</div>
        <span style="color:#999;margin-left:10px">{{item.title}}</span>
      </div>
      <!-- 当前步骤 -->
      <div class="steps" v-if="stepsIndex==index" @click="clickStep(index)">
        <div class="iconC" style="">{{index+1}}</div>
        <span style="margin-left:10px">{{item.title}}</span>
      </div>
      <!-- 之前一步 -->
      <div class="steps" v-if="stepsIndex>index" @click="clickStep(index)">
        <i class="el-icon-circle-check" style="font-size:24px;color:#3A89FF"></i>
        <span style="margin-left:10px">{{item.title}}</span>
      </div>
    </div>
    <!-- 引用示例 -->
    <!-- <steps :stepsIndex="createGuidelinesActive" :stepsData="createGuidelinesList" @clickStep="clickStep"></steps> -->
  </div>
</template>
<script>
export default {
  name: 'Steps',
  props: {
    stepsData: { // 步骤title数组
      type: Array,
      default: () => {
        return []
      }
    },
    stepsIndex: { // 当前选中的步骤
      type: Number,
      default: 1
    }
  },
  data() {
    return {
    }
  },
  methods: {
    // 点击步骤
    clickStep(index) {
      // this.$emit('clickStep', index)
    }
  }
}
</script>
<style lang="scss" scoped>
.wrap {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
}
.box {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-around;
  align-items: center;
}
.boxAfter::after {
  background: #e5e5e5;
  position: relative;
  left: 25px;
  display: block;
  width: 70px;
  height: 1px;
  content: "";
}
.steps {
  font-weight: 400;
  font-size: 14px;
  color: #333333;
  display: flex;
  align-items: center;
}
.iconN {
  width: 23px;
  height: 23px;
  background: #fff;
  color: #999;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  border: 1px solid #999;
}
.iconC {
  width: 24px;
  height: 24px;
  background: #3a89ff;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
}
</style>